/* eslint-disable */

import request from '@/utils/request'

export function getListSubTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/',
    method: 'get',
    params: query
  })
}

export function addSubTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction',
    method: 'post',
     data: query
  })
}

export function updateSubTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction',
    method: 'put',
     data: query
  })
}

export function deleteSubTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction',
    method: 'delete',
    data: query
  })
}
